/**
 * After a redemption, DSQ navigates its webview to our redirect URL, and core
 * redirects that to a guest page (the order confirmation, the payment link
 * for the rest, or checkout): it lands INSIDE the partner-points iframe
 * (prepits/project#4468). This puts that page in the top window instead.
 *
 * Only when the frame is our own partner-points page: the top window must be
 * same-origin (reading its location throws otherwise) and on
 * `/partner-points` (any locale prefix). Any other embedding of the guest
 * site is left alone.
 *
 * Returns whether it navigated the top window.
 */
export const breakOutOfPartnerPointsFrame = (win: Window = window): boolean => {
  const top = win.top;
  if (!top || top === win.self) {
    return false;
  }

  let topPath: string;
  try {
    topPath = top.location.pathname;
  } catch {
    return false;
  }
  if (!/\/partner-points\/?$/u.test(topPath)) {
    return false;
  }

  top.location.href = win.location.href;

  return true;
};
